import React, { useEffect } from "react";
import InputText from "../../../common/Input/InputText";
import { getAllLabReport } from "../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";

const CertificateDetails = ({ handleChange, medicalCertificateFormData, medicalCertificate }) => {
    const dispatch = useDispatch();
    const { clinicInfo } = useSelector((state) => state.clinic);
    const { token } = useSelector((state) => state.auth);
    const labReportId = sessionStorage.getItem("labReportId");
    const clinicId =clinicInfo?.[0]?.clinicId ||null;
    useEffect(() => {
        dispatch(getAllLabReport({ clinicId, id: labReportId, token }));
    }, [dispatch, clinicId, labReportId, token]);

    return (
        <>
            {/* eye */}
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">EYE</h4>
                    <div className="row">
                        <div className="col-xl-6">
                            <InputText
                                name="r_eye"
                                value={medicalCertificateFormData?.eye?.r_eye}
                                onChange={(e) => handleChange(e, "eye")}
                                label="R-EYE"
                            />
                        </div>
                        <div className="col-xl-6">
                            <InputText
                                name="l_eye"
                                value={medicalCertificateFormData?.eye?.l_eye}
                                onChange={(e) => handleChange(e, "eye")}
                                label="L-EYE"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* ear */}
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">EAR</h4>
                    <div className="row">
                        <div className="col-xl-6">
                            <InputText
                                name="r_ear"
                                value={medicalCertificateFormData?.ear?.r_ear}
                                onChange={(e) => handleChange(e, "ear")}
                                label="R-EAR"
                            />
                        </div>
                        <div className="col-xl-6">
                            <InputText
                                name="l_ear"
                                value={medicalCertificateFormData?.ear?.l_ear}
                                onChange={(e) => handleChange(e, "ear")}
                                label="L-EAR"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* SECV */}
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">SYSTEMATIC EXAMINATION CARDIO VASCULAR</h4>
                    <div className="row">
                        <div className="col-xl-4">
                            <InputText
                                name="BP"
                                value={medicalCertificateFormData?.SECV?.BP}
                                onChange={(e) => handleChange(e, "SECV")}
                                label="BP"
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="pulse"
                                value={medicalCertificateFormData?.SECV?.pulse}
                                onChange={(e) => handleChange(e, "SECV")}
                                label="PULSE"
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="heart"
                                value={medicalCertificateFormData?.SECV?.heart}
                                onChange={(e) => handleChange(e, "SECV")}
                                label="HEART"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* respiratorySystem */}
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">RESPIRATORY SYSTEM</h4>
                    <div className="row">
                        <div className="col-xl-6">
                            <InputText
                                name="throat"
                                value={medicalCertificateFormData?.respiratorySystem?.throat}
                                onChange={(e) => handleChange(e, "respiratorySystem")}
                                label="THROAT"
                            />
                        </div>
                        <div className="col-xl-6">
                            <InputText
                                name="lungs"
                                value={medicalCertificateFormData?.respiratorySystem?.lungs}
                                onChange={(e) => handleChange(e, "respiratorySystem")}
                                label="LUNGS"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* gastroIntestinal */}
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">GASTRO INTESTINAL</h4>
                    <div className="row">
                        <div className="col-xl-3">
                            <InputText
                                name="abdomen"
                                value={medicalCertificateFormData?.gastroIntestinal?.abdomen}
                                onChange={(e) => handleChange(e, "gastroIntestinal")}
                                label="ABDOMEN"
                            />
                        </div>
                        <div className="col-xl-3">
                            <InputText
                                name="CNS"
                                value={medicalCertificateFormData?.gastroIntestinal?.CNS}
                                onChange={(e) => handleChange(e, "gastroIntestinal")}
                                label="CNS"
                            />
                        </div>
                        <div className="col-xl-3">
                            <InputText
                                name="skin"
                                value={medicalCertificateFormData?.gastroIntestinal?.skin}
                                onChange={(e) => handleChange(e, "gastroIntestinal")}
                                label="SKIN"
                            />
                        </div>
                        <div className="col-xl-3">
                            <InputText
                                name="psychatry"
                                value={medicalCertificateFormData?.gastroIntestinal?.psychatry}
                                onChange={(e) => handleChange(e, "gastroIntestinal")}
                                label="PSYCHATRY"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* other */}
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">OTHERS</h4>
                    <div className="row">
                        <div className="col-xl-4">
                            <InputText
                                name="hydrocele"
                                value={medicalCertificateFormData?.other?.hydrocele}
                                onChange={(e) => handleChange(e, "other")}
                                label="HYDROCELE"
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="hernia"
                                value={medicalCertificateFormData?.other?.hernia}
                                onChange={(e) => handleChange(e, "other")}
                                label="HERNIA"
                            />
                        </div>
                        <div className="col-xl-4">
                            <InputText
                                name="vericosVeins"
                                value={medicalCertificateFormData?.other?.vericosVeins}
                                onChange={(e) => handleChange(e, "other")}
                                label="VARICOSE VEINS"
                            />
                        </div>
                        <div className="col-xl-6">
                            <InputText
                                name="extremities"
                                value={medicalCertificateFormData?.other?.extremities}
                                onChange={(e) => handleChange(e, "other")}
                                label="EXTREMITIES"
                            />
                        </div>
                        <div className="col-xl-6">
                            <InputText
                                name="deformities"
                                value={medicalCertificateFormData?.other?.deformities}
                                onChange={(e) => handleChange(e, "other")}
                                label="DEFORMITIES"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default CertificateDetails;